import en from "./en.json";
import de from "./de.json";
import fr from "./fr.json";

const languages = [
  { code: "en", countryIso2: "gb", labelKey: "general.english" },
  { code: "de", countryIso2: "de", labelKey: "general.german" },
  { code: "fr", countryIso2: "fr", labelKey: "general.french" },
] as const;

export type AppUiLocale = (typeof languages)[number]["code"];

const Locales = {
  languages,
  resources: {
    en: { translation: en },
    de: { translation: de },
    fr: { translation: fr },
  },
  fallbackLng: "en" as AppUiLocale,
};

export default Locales;
